// Your web app's Firebase configuration
import AppConfig from "./AppConfig";
const firebaseConfigProduction = {
  apiKey: "AIzaSyDtE2JuAMiQQa6TszRaGVyRph55DSC9Y2Q",
  authDomain: "itqanturk-insurances-system.firebaseapp.com",
  databaseURL:
    "https://itqanturk-insurances-system-default-rtdb.firebaseio.com",
  projectId: "itqanturk-insurances-system",
  storageBucket: "itqanturk-insurances-system.appspot.com",
  messagingSenderId: "556915141727",
  appId: "1:556915141727:web:9ac7177cee0b5356697fea",
};
const firebaseConfigDevelopment = {
  apiKey: "AIzaSyBcvg8J0LVK1v3wuhf8oBQIgCy-8YAmgeU",
  authDomain: "itqanturk-insurances-local.firebaseapp.com",
  databaseURL: "https://itqanturk-insurances-local-default-rtdb.firebaseio.com",
  projectId: "itqanturk-insurances-local",
  storageBucket: "itqanturk-insurances-local.appspot.com",
  messagingSenderId: "290076808121",
  appId: "1:290076808121:web:50f5848d42e129d3b75c68",
  measurementId: "G-44RLHB9B6M",
};
export default process.env.NODE_ENV === "production"
  ? window.location.host === AppConfig.brandDomain
    ? firebaseConfigProduction
    : firebaseConfigDevelopment
  : firebaseConfigDevelopment;
